import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style

router.beforeEach(async(to,from,next) => {

  if(store.state.site_info) document.title = store.state.site_info.site_name

  NProgress.start()
  const isLogin = store.state.loginState
  const siteInfo = store.state.site_info
  if(!siteInfo) await store.dispatch('setSiteInfo')
  if (isLogin){
    // 再次获取用户信息
    const hasGetUserInfo = store.state.user_info && store.state.user_info.name
    if(to.path.indexOf('/login') !== -1){
      if(!hasGetUserInfo) await store.dispatch('setUserInfo')
      next({path: '/'})
    }else{
      next()
    }
  }else{
    // 未登录的情况跳转登录
    if(to.path.indexOf('/login') !== -1){
      next()
    }else{
      next({
        path: '/login',
        query: {
          redirect: to.path,
          ...to.query
        }
      })
    }
  }
})
router.afterEach(() => {
  NProgress.done()
})
